export default {"src":"/_next/static/media/manta-color.8b2690ac.svg","height":874,"width":874,"blurWidth":0,"blurHeight":0};